var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubtResolutionDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 921"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 922",
    cx: 8,
    cy: 8,
    r: 3,
    fill: "#D97706"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubtResolutionDot);
export default __webpack_public_path__ + "static/media/doubtResolutionDot.092d2d2d9386f1ef948ba966bd202c78.svg";
export { ForwardRef as ReactComponent };